var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 53,
    viewBox: "0 0 60 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 53,
    rx: 5,
    fill: "#F54F59"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 34.7816V38.7566C25.25 39.8109 25.667 40.8219 26.4094 41.5674C27.1517 42.3128 28.1585 42.7316 29.2083 42.7316H45.0417C46.0915 42.7316 47.0983 42.3128 47.8406 41.5674C48.583 40.8219 49 39.8109 49 38.7566V14.9066C49 13.8524 48.583 12.8413 47.8406 12.0959C47.0983 11.3504 46.0915 10.9316 45.0417 10.9316H30C27.814 10.9316 25.25 12.7114 25.25 14.9066V18.8816M18.9167 34.7816L11 26.8316L18.9167 18.8816M37.9167 26.8316C37.9167 26.8316 22.4766 26.8316 12.5833 26.8316",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIcon);
export default __webpack_public_path__ + "static/media/modal-icon.4a35d0e3e7b7b9c3d36cb614ee91dd6f.svg";
export { ForwardRef as ReactComponent };